import { services } from "../data/mock";
import { TrendingUp, Cloud, Phone, Code, CheckCircle, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const iconMap = {
  TrendingUp,
  Cloud,
  Phone,
  Code,
};

const Services = () => {
  const IconComponent = ({ name, ...props }) => {
    const Icon = iconMap[name] || Code;
    return <Icon {...props} />;
  };

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-700 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Our Services
            </h1>
            <p className="text-blue-100 text-lg md:text-xl max-w-3xl mx-auto">
              Comprehensive technology solutions designed to drive innovation, efficiency, and growth for your business
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`grid md:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? "md:flex-row-reverse" : ""
                }`}
              >
                <div className={`${index % 2 === 1 ? "md:order-2" : ""}`}>
                  <div className="relative group">
                    <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-blue-400 rounded-2xl opacity-20 blur-2xl group-hover:opacity-30 transition-opacity duration-300" />
                    <img
                      src={service.image}
                      alt={service.title}
                      className="relative rounded-2xl shadow-2xl w-full h-80 object-cover"
                    />
                    <div className="absolute top-6 left-6 w-16 h-16 bg-white rounded-xl shadow-lg flex items-center justify-center">
                      <IconComponent name={service.icon} size={32} className="text-blue-600" />
                    </div>
                  </div>
                </div>

                <div className={`${index % 2 === 1 ? "md:order-1" : ""}`}>
                  <span className="text-blue-600 font-semibold text-sm uppercase tracking-wider">
                    Service #{service.id}
                  </span>
                  <h2 className="text-4xl font-bold text-gray-900 mt-4 mb-6">
                    {service.title}
                  </h2>
                  <p className="text-gray-600 text-lg leading-relaxed mb-6">
                    {service.description}
                  </p>

                  <div className="space-y-3 mb-8">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Key Features:</h3>
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start">
                        <CheckCircle size={20} className="text-blue-600 mr-3 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <Link to="/contact">
                    <Button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold">
                      Get Started
                      <ArrowRight className="ml-2" size={18} />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Need a Custom Solution?
          </h2>
          <p className="text-gray-600 text-lg mb-8">
            We understand that every business is unique. Let's discuss your specific requirements and create a tailored solution.
          </p>
          <Link to="/contact">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 text-lg font-semibold rounded-lg">
              Contact Our Team
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
